import React from "react";
import { IMessageProps } from "./types";
import { FpIcon, OfaText } from "@fortius/prime-ui";
import * as Styled from "./index.styled";

export const Message: React.FC<IMessageProps> = ({
  type,
  title,
  icon,
  className,
  testId,
  onClick,
  children
}) => {
  return (
    <Styled.Message
      type={type}
      className={className}
      data-testid={testId}
      onClick={onClick}
    >
      {icon ?? <FpIcon icon="InformationOutline" />}
      <div>
        {title && (
          <OfaText color="primary" weight="bold">
            {title}
          </OfaText>
        )}
        {children}
      </div>
    </Styled.Message>
  );
};
